import React from 'react';

import PropTypes from 'prop-types';

import styles from './GraphData.module.scss';

const shareButton = require('./imgs/share-button.svg');
const watchIcon = require('./imgs/watch-icon.svg');


const GraphData = ({ graphData }) => {
  /* TODO: Include table item row data and
  .map each out based on template below */
  const percentChange = 18.3;
  const widthNormalizer = percentChange < 0 ? -0.50 : 0.50;
  const rangeColor = percentChange < 0 ? '#E53935' : '#179F66';
  return (
    <div className={styles.graphDataWrapper}>
      <div className={styles.graphDataContainer}>
        {/* HEADER */ }
        <div className={styles.graphDataHeader}>
          <div>
            <div style={{ backgroundColor: graphData.highlightColor }} />
            <p>{graphData.title || ''}</p>
          </div>
          <img alt="share" src={shareButton} />
        </div>
        {/* TABLE */}
        {/* TABLE HEADER */}
        <div className={styles.graphTableContainer}>
          <div className={styles.graphTableHeader}>
            <div>
              <p>Category | Brand</p>
            </div>
            <div>
              <div>
                <p>Sales</p>
                <p>$(M)</p>
              </div>
              <div>
                <p>YoY</p>
                <p>& Chg</p>
              </div>
            </div>
          </div>
        </div>
        {/* GRAPH TABLE ROW ITEM TEMPLATE */}
        <div className={styles.graphTableItem}>
          <div>
            <span>Baby Care | Diapers</span>
            <p>Huggies</p>
            <img alt="watch" src={watchIcon} />
          </div>
          <div>
            <div>
              <p>3.644</p>
            </div>
            <div className={styles.rangeContainer}>
              <p
                className={!percentChange ? styles.noChange : null}
                style={{ color: rangeColor }}
              >
                {percentChange || '-'}
              </p>
              <div
                style={{ width: (percentChange * widthNormalizer) }}
                className={[
                  styles.range,
                  percentChange < 0 ? styles.negative : styles.positive,
                ].join(' ')}
              />
              <svg>
                <line x1="0" y1="0" x2="0" y2="150" stroke="#E5E5E5" strokeWidth="2" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GraphData.propTypes = {
  graphData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    highlightColor: PropTypes.string.isRequired,
  }).isRequired,
};

export default GraphData;
